// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import PageHeader from './PageHeader';
import PageTitle from './PageTitle';

/** @typedef {{
  title?: string,
  extraTitleContent?: JSX.Element,
  children: JSX.Element | JSX.Element[]
}} PagePropsType */

/** @type { StatelessComponent<PagePropsType> } */
const Page = ({ title, extraTitleContent, children }) => (
  <div>
    {title ? <PageTitle title={title} /> : null}{' '}
    {/* NB: PageTitle updates PageHeader via side effects */}
    <PageHeader extraTitleContent={extraTitleContent} />
    <div className="container-fluid">{children}</div>
  </div>
);

Page.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  extraTitleContent: PropTypes.node,
};

export default Page;
